import { render, staticRenderFns } from "./Panoramic.vue?vue&type=template&id=24d1c400&scoped=true"
import script from "./Panoramic.vue?vue&type=script&lang=js"
export * from "./Panoramic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1c400",
  null
  
)

export default component.exports